import { useEffect, useRef, useState } from 'react';
import { useBusiness } from '../context/BusinessContext';

export default function BusinessSwitcher() {
  const { businesses, activeBusiness, setActiveId } = useBusiness();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function onDocClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  return (
    <div className="switcher" ref={ref}>
      <button
        className="switcher__btn"
        style={{ borderLeftColor: activeBusiness?.color, borderLeftWidth: 4 }}
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="switcher__tag" style={{ background: activeBusiness?.color }}>{activeBusiness?.short}</span>
        <span className="switcher__group">
          <span className="switcher__label">Business</span>
          <span className="switcher__name">{activeBusiness?.name}</span>
        </span>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </button>

      {open && (
        <ul className="switcher__menu" role="listbox">
          {businesses.map((b) => (
            <li key={b.id}>
              <button
                role="option"
                aria-selected={b.id === activeBusiness?.id}
                className={'switcher__item' + (b.id === activeBusiness?.id ? ' is-active' : '')}
                onClick={() => { setActiveId(b.id); setOpen(false); }}
              >
                <span className="switcher__dot" style={{ background: b.color }} />
                <span className="switcher__item-name">{b.name}</span>
                {b.id === activeBusiness?.id && (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" className="switcher__check">
                    <path d="M5 12l5 5L20 7" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                )}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
